import fetch from '../../utils/fetch'

export function getUserCouponList(params) {
    return fetch({
        url: '/api/userCoupon/userCouponList',
        method: 'GET',
        params
    })
}

export function userGiveCoupon(params) {
    return fetch({
        url: '/api/userCouponGive/userGiveCoupon',
        method: 'POST',
        data:params
    })
}

export function getAvailableCouponList(params) {
    return fetch({
        url: '/api/userCoupon/userAvailableCouponList',
        method: 'GET',
        params
    })
}

export function userUseCoupon(params) {
    return fetch({
        url: '/api/userCoupon/userUseCoupon',
        method: 'POST',
        data:params
    })
}

export function userAvailableCouponListByUserId(params) {
    return fetch({
        url: '/api/userCoupon/userAvailableCouponListByUserId',
        method: 'GET',
        params
    })
}
